import type { ReactNode } from 'react'

import {
  AlertState,
  CenteredState,
  type StatusStateLayout,
} from './statusState'

export type EmptyStateProps = {
  /** Visual layout. Default is the web-app centered look. */
  layout?: StatusStateLayout
  /** Optional icon. Alert layout uses the Chakra info indicator when omitted. */
  icon?: ReactNode
  /** Heading. Callers supply copy; there is no default title. */
  title?: string
  /** Supporting empty-state detail. */
  description?: string
  /** Optional call to action (for example a create button). */
  action?: ReactNode
}

/**
 * Empty-results display. Use `layout="alert"` for the inline info alert used
 * by list pages.
 */
export const EmptyState = ({
  layout = 'centered',
  icon,
  title,
  description,
  action,
}: EmptyStateProps) => {
  if (layout === 'alert') {
    return (
      <AlertState
        status="info"
        icon={icon}
        title={title}
        description={description}
        action={action}
      />
    )
  }

  return (
    <CenteredState
      icon={icon}
      title={title}
      description={description}
      action={action}
      role="status"
    />
  )
}
